import Cookies from 'js-cookie';
import * as Sentry from "@sentry/vue";

const eips = document.getElementsByClassName('eip');

const showPopup = function (e, eip) {
    e.preventDefault();

    let displayPopup = false;
    switch (eip.dataset.showOn) {
        case 'move-mouse-up':
            displayPopup = e.clientY <= 0;
            break
        // todo in the future implement other actions to display popup
    }

    if (
        window.sessionStorage?.getItem(`eip-${eip.dataset.id}-closed`) !== '1'
        && displayPopup
    ) {
        eip.classList.remove('d-none');
        document.removeEventListener('mouseleave', showPopup);
    }
};

const closePopup = function (e, eip) {
    e.preventDefault();
    try {
        window.sessionStorage?.setItem(`eip-${eip.dataset.id}-closed`, 1);
    } catch {}
    const expiresDate = new Date();
    expiresDate.setHours(expiresDate.getHours() + parseInt(eip.dataset.showAgainIn));
    Cookies.set(`popup-${eip.dataset.id}`, 'eip-delay', {expires: expiresDate});
    eip.classList.add('d-none');
};

let eipPageVisited = window.sessionStorage?.getItem('eip-page-visited') ?? 0;
eipPageVisited = parseInt(eipPageVisited) + 1;
try {
    window.sessionStorage?.setItem('eip-page-visited', eipPageVisited);
} catch {}

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(async () => {
        try {
            const response = await fetch(
                `${window.env.POPUP_API}/?url=${window.location.pathname}`,
                { credentials: 'include' }
            );

            if (!response.ok) {
                return;
            }
            const popup = await response.text();
            if (popup !== null) {
                document.querySelector('main').insertAdjacentHTML('beforeend', popup);

                const now = Date.now();
                const eip = document.getElementsByClassName('eip')[0];

                if (typeof eip === 'undefined') {
                    return;
                }

                const {from, to} = eip.dataset;
                if (
                    (new Date(from)) <= now && (new Date(to)) >= now
                    && Cookies.get(`popup-${eip.dataset.id}`) !== 'eip-delay'
                    && eipPageVisited >= parseInt(eip.dataset.visitedPageCount)
                ) {
                    setTimeout(function () {
                        document.addEventListener('mouseleave', (e) => showPopup(e, eip));
                        eip.getElementsByClassName('eip-close')[0].addEventListener('click', (e) => closePopup(e, eip));
                        eip.getElementsByClassName('eip-backdrop')[0].addEventListener('click', (e) => closePopup(e, eip));
                    }, parseInt(eip.dataset.visitedPageTime) * 1000);
                }
            }
        } catch (error) {
            Sentry.captureException(error);
        }
    }, 0);
});
